import axios from 'axios'

export const state = () => ({
  userAdmin: null,
  userAdminFull: null,
});

export const actions = {
  getUserAdmin: async function (params) {
    // const adminToken = this.$cookies.get('adminToken');
    // if (!adminToken) {
    //   return
    // }
    //
    // const headers = {
    //   headers: {
    //     Authorization: `Bearer ${adminToken}`
    //   }
    // }

    const userAdmin = await axios.get(`${process.env.baseApiUrl}/admin/api-admin-user/session`).then((res) => {
      return res.data?.user || null
    }).catch(() => {
      return null
    });
    if (!userAdmin) {
      return
    }

    // const userAdminGroups = await axios.get(`${process.env.baseApiUrl}/admin/api-admin-user/${userAdmin?.id}?expand=groups`, headers).then((res) => {
    //   return res.data
    // }).catch(() => {
    //   return {}
    // });

    params.commit('setUserAdmin', userAdmin);
    // params.commit('setUserAdminFull', userAdminGroups);
  }
};

export const mutations ={
  setUserAdmin: function (state, userAdmin) {
    state.userAdmin = userAdmin;
  },
  setUserAdminFull: function (state, userAdminFull) {
    state.userAdminFull = userAdminFull;
  },
}
